import type { FocusEventHandler, ReactNode } from 'react'

import { cn } from '@/utils/cn'

interface PageWrap {
	children: ReactNode
	hasPropPanel?: boolean
	maxWidth?: string
	onBlur?: FocusEventHandler<HTMLDivElement>
	onMouseEnter?: () => void
}
export const PageWrap = ({
	children,
	hasPropPanel,
	onBlur,
	onMouseEnter,
	maxWidth,
}: PageWrap) => {
	const className = cn(
		`relative h-full pt-2 pb-0 pl-2 ${hasPropPanel ? 'pr-10' : 'pr-4'}`,
	)

	return (
		<div
			style={{ maxWidth }}
			onBlur={onBlur}
			onMouseEnter={onMouseEnter}
			className={className}
		>
			{children}
		</div>
	)
}
